<template>
  <section id="writeIn" class="content">
    <h5 class="title">Can't find your nominee?</h5>
    <p>Click the button below to add a new record to our database.</p>
    <div class="columns is-mobile" v-for="id in writeIns" :key="id">
      <div class="field is-horizontal column is-6">
        <div class="field-label is-normal">
          <label :for="`write-in-name-${id}`" class="label">Name</label>
        </div>
        <div class="field-body">
          <div class="field">
            <p class="control">
              <input
                type="text"
                :id="`write-in-name-${id}`"
                :name="`write-in-name-${id}`"
                class="input vote-field"
                placeholder="Your Nomination"
                @blur="updateSubmission"
              >
            </p>
          </div>
        </div>
      </div>
      <div class="field is-horizontal column is-6">
        <div class="field-label is-normal is-hidden-tablet-only">
          <label :for="`write-in-category-${id}`" class="label">
            Category
          </label>
        </div>
        <div class="field-body">
          <div class="field">
            <div class="control">
              <div class="select">
                <select @change="updateSubmission" :name="`write-in-category-${id}`">
                  <option v-for="(category, index) in categories" :key="index">
                    {{ category }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <a class="button is-dark is-outlined" @click="newWriteIn" v-show="writeIns !== writeInLimit">
      <span class="icon is-small">
        <fa icon="plus"></fa>
      </span>
      <span>Add</span>
    </a>
  </section>
</template>

<script>
export default {
  data() {
    return {
      writeIns: 0,
    };
  },
  computed: {
    writeInLimit() {
      return this.$store.state.write_in_limit;
    },
    categories() {
      const allCategories = [];
      Object.keys(this.$store.state.categories).forEach((key) => {
        this.$store.state.categories[key].forEach((item) => {
          allCategories.push(item);
        });
      });
      return allCategories.sort();
    },
  },
  methods: {
    newWriteIn() {
      if (this.writeIns < this.writeInLimit) {
        this.writeIns += 1;
      }

      const nameField = {
        name: `write-in-name-${this.writeIns}`,
        value: '',
      };
      this.$store.dispatch('addToSubmission', nameField);

      const categoryField = {
        name: `write-in-category-${this.writeIns}`,
        value: this.categories[0],
      };
      this.$store.dispatch('addToSubmission', categoryField);
    },
    updateSubmission(e) {
      const field = {
        name: e.target.name,
        value: e.target.value,
      };
      this.$store.dispatch('addToSubmission', field);
      this.$store.dispatch('updateVoteCount');
    },
  },
};
</script>
